import { motion } from 'framer-motion';
import { Twitter, Heart, Flame, ExternalLink } from 'lucide-react';

const iconMap = {
    twitter: Twitter,
    heart: Heart,
    flame: Flame,
    default: ExternalLink
};

export const LinkCard = ({ link, index, onLinkClick }) => {
    const Icon = iconMap[link.icon] || iconMap.default;

    const handleClick = () => {
        onLinkClick(link);
        window.open(link.url, '_blank', 'noopener,noreferrer');
    };

    return (
        <motion.button
            data-testid={`link-card-${link.id}`}
            onClick={handleClick}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.08 + 0.15, duration: 0.45, ease: 'easeOut' }}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.985 }}
            className={`
                w-full p-4 rounded-2xl
                flex items-center gap-4
                transition-colors duration-300
                group cursor-pointer
                ${link.highlight
                    ? 'bg-gradient-to-r from-rose-500/90 to-rose-400/90 border border-rose-200/30 shadow-[0_8px_30px_-6px_rgba(251,113,133,0.55)]'
                    : 'glass border border-rose-200/10 hover:border-rose-300/30'
                }
            `}
        >
            <div className={`
                w-11 h-11 rounded-xl flex items-center justify-center shrink-0
                ${link.highlight
                    ? 'bg-white/20 backdrop-blur-sm'
                    : 'bg-rose-300/10 group-hover:bg-rose-300/15'
                }
                transition-colors duration-300
            `}>
                <Icon
                    className={`
                        w-5 h-5
                        ${link.highlight ? 'text-white fill-white' : 'text-[#d62828] group-hover:text-[#b91c1c]'}
                        transition-colors duration-300
                    `}
                />
            </div>

            <span className={`
                flex-1 text-left font-medium tracking-wide
                ${link.highlight ? 'text-white text-base' : 'text-rose-100/90 group-hover:text-white text-[0.95rem]'}
                transition-colors duration-300
            `}>
                {link.name}
            </span>

            <ExternalLink className={`w-4 h-4 ${link.highlight ? 'text-white/80' : 'text-rose-200/40 group-hover:text-rose-200/80'} transition-colors duration-300`} />
        </motion.button>
    );
};

export default LinkCard;
